import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { TabView, TabPanel } from 'primereact/tabview';
import { Badge } from 'primereact/badge';
import '../../../assets/css/teacherMasterDetail.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import { InputTextarea } from 'primereact/inputtextarea';
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { apiBase } from '../../../utils/config';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import UploadFile from '../../UploadFile/UploadFile';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const ViewEditTeacherDetails = (props) => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    const signUploadRef = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const [signPath, setSignPath] = useState('');
    const [previewSignPath, setPreviewSignPath] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [personalDetailId, setPersonalDetailId] = useState('');
    const [fullName, setFullName] = useState("");
    const [teacherId, setTeacherId] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [alternateMobileNumber, setAlternateMobileNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [selectedGender, setSelectedGender] = useState(null);
    const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
    const [selectedNationality, setSelectedNationality] = useState(null);
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [aadharNo, setAadharNo] = useState('');
    const [dob, setDob] = useState(null);
    const [doj, setDoj] = useState(null);
    const [age, setAge] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [permanentAddress, setPermanentAddress] = useState('');
    const [oldPermanentAddress, setOldPermanentAddress] = useState('');
    const [lastOrganzation, setLastOrganzation] = useState('');
    const [experience, setExperience] = useState('');
    const [position, setPosition] = useState('');
    const genderOptions = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
    const nationalityOptions = [{ label: 'Indian', value: 'indian' }, { label: 'Other', value: 'other' }];
    const [qualifications, setQualifications] = useState([]);
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrText, setEmailErrText] = useState('');
    const [profilePath, setProfilePath] = useState(null);
    const [isRandom, setIsRandom] = useState(false);
    const [languageList, setLanguageList] = useState([]);
    const [bloodList, setBloodList] = useState([]);
    const [religionList, setReligionList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const yearOptions = Array.from({ length: 50 }, (_, i) => ({ label: `${2024 - i}`, value: `${2024 - i}` }));
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [isSubjectTeacher, setIsSubjectTeacher] = useState(false);
    const [isClassTeacher, setIsClassTeacher] = useState(false);
    const [assignedClass, setAssignedClass] = useState([]);
    const [assignedSubject, setAssignedSubject] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [selectedShiftId, setSelectedShiftId] = useState(null);
    const [shiftTime, setShiftTime] = useState('-');
    const [classTeacherName, setClassTeacherName] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [typeName, setTypeName] = useState('');
    const [modelType, setModelType] = useState('');
    const [imageQuality, setImageQuality] = useState(0.2);
    const [isEdit, setIsEdit] = useState(props?.location?.state?.isEdit || false);
    const [section, setSection] = useState('Basic Details');


    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await getUserDetailById();
                await GetShiftList(loginData?._id);
                await GetConfigurationData(loginData?._id);
                await GetTypeList(loginData?._id);
                await GetLanguageList(loginData?._id);
                await GetBloodList(loginData?._id);
                await GetCasteList(loginData?._id);
                await GetReligionList(loginData?._id);
                await getPersonDetail();
                await getQualificationDetail();
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setImageQuality(!CommonConfig.isEmpty(res?.data?.TeacherConfig) ? res?.data?.TeacherConfig : 0.2);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTypeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTypeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTypeList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onReferesh = async () => {
        await getUserDetailById();
        await GetShiftList(securityUserID);
        await GetLanguageList(securityUserID);
        await GetBloodList(securityUserID);
        await GetCasteList(securityUserID);
        await GetReligionList(securityUserID);
        await getPersonDetail();
        await getQualificationDetail();
    }

    const GetShiftList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getShiftList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setShiftList(res?.data?.filter(y => y?.Status === 'Active')?.map(x => ({
                        label: `${x?.ShiftName}(${formattedTime(x?.ShiftStart)} - ${formattedTime(x?.ShiftEnd)})`,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const formattedTime = (date) => {
        return new Date(date).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        })
    };

    const GetLanguageList = async (id) => {
        try {
            await api.get(APIConstant.path.getLanguageList).then(async response => {
                let res = response;
                if (res.success) {
                    setLanguageList(res.data.map(x => ({
                        ...x,
                        label: x?.LanguageName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const GetBloodList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBloodList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBloodList(res.data.map(x => ({
                        label: x?.BloodName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetCasteList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCasteList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCasteList(res.data.map(x => ({
                        label: x?.CasteName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetReligionList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getReligionList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setReligionList(res.data.map(x => ({
                        label: x?.ReligionName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const addQualification = () => {
        setQualifications([...qualifications, {
            id: Date.now(),
            _id: '',
            degree: '',
            passingYear: '',
            college: '',
            university: '',
            percentage: ''
        }]);
    };

    const removeQualification = (id) => {
        setQualifications(qualifications.filter(q => q._id !== id));
    };

    const updateQualification = (id, field, value) => {
        const updatedQualifications = qualifications.map(q =>
            q.id === id ? { ...q, [field]: value } : q
        );
        setQualifications(updatedQualifications);
    };

    const getUserDetailById = async (ID) => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            await api
                .post(APIConstant.path.getUserById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setFullName(res?.data?.Name);
                        setMobileNumber(res?.data?.Phone);
                        setEmailAddress(res?.data?.Email);
                        setTypeName(res?.data?.TypeId);
                        setProfilePath(res?.data?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${res?.data?.ProfilePhotoUrl}` : null);
                        setSignPath(res?.data?.SignPath ? `${apiBase}/UserProfilePic/${res?.data?.SignPath}` : null);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const getPersonDetail = async (ID) => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            await api
                .post(APIConstant.path.GetPersonalDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        setPersonalDetailId(res?.data?._id);
                        setTeacherId(res?.data?.ProfileId);
                        setAadharNo(res?.data?.AadharNo);
                        setSelectedGender(res?.data?.Gender);
                        setDob(res?.data?.DOB ? new Date(res?.data?.DOB) : null);
                        setAge(res?.data?.Age);
                        setSelectedNationality(res?.data?.Nationality);
                        setSelectedBloodGroup(res?.data?.BloodGroup);
                        setSelectedReligion(res?.data?.Religion);
                        setSelectedCategory(res?.data?.Category);
                        setLanguages(res?.data?.Language ? res?.data?.Language.split(',') : []);
                        setAlternateMobileNumber(res?.data?.AlternateContact);
                        setCurrentAddress(res?.data?.CurrentAddress);
                        setPermanentAddress(res?.data?.PermanentAddress ?? '');
                        setPinCode(res?.data?.PinCode);
                        setDoj(res?.data?.DOJ ? new Date(res?.data?.DOJ) : null);
                        setExperience(res?.data?.JobExperience)
                        setLastOrganzation(res?.data?.LastOrganzation);
                        setPosition(res?.data?.LastJobPosition);
                        setIsSubjectTeacher(res?.data?.IsSubjectTeacher);
                        setIsClassTeacher(res?.data?.IsClassTeacher);
                        setAssignedClass(res?.data?.AssignedClass ? res?.data?.AssignedClass.split(',') : []);
                        setAssignedSubject(res?.data?.AssignedSubject ? res?.data?.AssignedSubject.split(',') : []);
                        setSelectedShiftId(res?.data?.ShiftId);
                        setShiftTime(res?.data?.ShiftName ? `${res?.data?.ShiftName}(${formattedTime(res?.data?.ShiftStart)} - ${formattedTime(res?.data?.ShiftEnd)})` : '');
                        setClassTeacherName(res?.data?.AssignedClassTeacherName);
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const getQualificationDetail = async (ID) => {
        try {
            let data = {
                id: props?.location?.state?.userId,
            };
            await api
                .post(APIConstant.path.GetQualificationDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        let resData = res?.data;
                        if (resData.length) {
                            const qualificationsData = resData.map((x) => ({
                                id: Date.now(),
                                _id: x?._id,
                                degree: x?.DegreeName,
                                passingYear: x?.PassingYear,
                                college: x?.CollegeName,
                                university: x?.University,
                                percentage: x?.Percentage
                            }));
                            setQualifications(qualificationsData);
                        }
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const saveDetails = async (e) => {
        await AddEditUserDetail();
        await AddEditPersonalDetail();
        await AddEditQualificationDetail();
        await onReferesh();
        navigate('/teacher-master')
    }

    const AddEditUserDetail = async () => {
        try {
            const formData = new FormData();
            formData.append("id", props?.location?.state?.userId);
            formData.append("Name", fullName.trim().replace(/\s+/g, ' '));
            formData.append("Email", emailAddress);
            formData.append("Phone", mobileNumber);
            formData.append("TypeId", typeName);
            formData.append("IsNoLogin", true);
            if (profilePath && profilePath.type) {
                formData.append("userProfilePic", profilePath);
            } else if (CommonConfig.isEmpty(profilePath)) {
                formData.append("userProfilePic", '');
            }
            if (signPath && signPath.type) {
                formData.append("signPath", signPath);
            } else if (CommonConfig.isEmpty(signPath)) {
                formData.append("signPath", '');
            }
            Loader.show();
            await api.post(APIConstant.path.AddUpdateUser, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                    } else {
                        Toast.error({ message: res.message });
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: 'Failed to update user details' });
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Toast.error({ message: 'An error occurred' });
            Loader.hide();
            catchResponse(err);
        }
    };

    const AddEditPersonalDetail = async (e) => {
        try {
            let data = {
                PersonalId: personalDetailId,
                UserId: props?.location?.state?.userId,
                AadharNo: aadharNo,
                Gender: selectedGender,
                DOB: dob ? moment(dob).format("YYYY-MM-DD") : null,
                Age: age,
                Nationality: selectedNationality,
                BloodGroup: selectedBloodGroup,
                Religion: selectedReligion,
                Category: selectedCategory,
                Language: languages.length > 1 ? languages.join(',') : languages[0],
                AlternateContact: alternateMobileNumber,
                PinCode: pinCode,
                CurrentAddress: currentAddress,
                PermanentAddress: permanentAddress,
                DOJ: doj ? moment(doj).format("YYYY-MM-DD") : null,
                JobExperience: experience,
                LastOrganzation: lastOrganzation,
                LastJobPosition: position,
                ShiftId: selectedShiftId,
                CreatedBy: securityUserID
            };
            Loader.show();
            await api.post(APIConstant.path.AddPersonalDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: 'Details Updated' });
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch((err) => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const AddEditQualificationDetail = async (e) => {
        try {
            if (qualifications) {
                qualifications.map(async (x) => {
                    let data = {
                        id: x._id,
                        UserId: props?.location?.state?.userId,
                        DegreeName: x.degree,
                        PassingYear: x.passingYear,
                        CollegeName: x.college,
                        University: x.university,
                        Percentage: x.percentage,
                        CreatedBy: securityUserID
                    };
                    Loader.show();
                    await api.post(APIConstant.path.AddQualificationDetail, data).then(async response => {
                        let res = response;
                        if (res.success) {
                            Loader.hide();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                        .catch((err) => {
                            Loader.hide();
                        });
                })

            }
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        if (type === 'FullName') {
            setFullName(alphanumericValue);
        } else if (type === 'MobileNo') {
            setMobileNumber(numericValue);
        } else if (type === 'AlternateNo') {
            setAlternateMobileNumber(numericValue);
        } else if (type === 'AadharNo') {
            setAadharNo(numericValue);
        } else if (type === 'Age') {
            setAge(numericValue);
        } else if (type === 'PinCode') {
            setPinCode(numericValue);
        } else if (type === 'Experience') {
            setExperience(numericValue);
        } else if (type === 'LastOrganization') {
            setLastOrganzation(alphanumericValue);
        } else if (type === 'LastJob') {
            setPosition(alphanumericValue);
        }
    };

    const handleCheckBox = (e, type) => {
        setIsRandom(e.checked);
        if (e.checked) {
            setOldPermanentAddress(permanentAddress);
            setPermanentAddress(currentAddress);
        } else {
            setPermanentAddress(oldPermanentAddress);
            setOldPermanentAddress('');
        }
    }

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const maxLength = 50;
        if (value.length <= maxLength) {
            setEmailAddress(value);
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(value)) {
            setEmailErr(true);
            setEmailErrText('Please enter a valid email address.');
        } else {
            setEmailErr(false);
            setEmailErrText('');
        }
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (!selectedFile) return;
        const img = new Image();
        img.onload = async () => {
            const aspectRatio = img.width / img.height;
            const expectedRatio = 3 / 4;
            const tolerance = 0.01;

            const canvas = document.createElement('canvas');
            const maxWidth = 300;
            const width = maxWidth;
            const height = width / aspectRatio;

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        const compressedFile = new File([blob], selectedFile.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now()
                        });

                        setProfilePath(compressedFile);
                        const compressedURL = URL.createObjectURL(blob);
                        setPreviewProfilePath(compressedURL);
                    }
                },
                'image/jpeg',
                imageQuality
            );
        };

        img.onerror = () => {
            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }
            Toast.error({ message: 'Error loading the image.' });
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    if (modelType === 'Sign') {
                        setSignPath("")
                        setPreviewSignPath('');
                        if (signUploadRef.current) {
                            signUploadRef.current.clear();
                        }
                    } else {
                        setProfilePath("")
                        setPreviewProfilePath('');
                        if (fileUploadRef.current) {
                            fileUploadRef.current.clear();
                        }
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const calculateAge = (dob) => {
        if (!dob) return '';
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleDobChange = (e) => {
        const selectedDob = e.value;
        setDob(selectedDob);
        setAge(calculateAge(selectedDob));
    };

    const uploadHandler = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                setSignPath(selectedFile);
                const fileURL = URL.createObjectURL(selectedFile);
                setPreviewSignPath(fileURL);
            };
            img.onerror = () => {
                if (signUploadRef.current) {
                    signUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleDelete = (type) => {
        setIsDeleteConfirmation(true);
        setModelType(type);
    };

    return (
        <div className="student-master-container">
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/teacher-master')}></i>
                    <h2>{!isEdit ? 'View' : 'Edit'} Teacher Master</h2>
                </div>
                {!isEdit && (
                    <Button
                        label="Edit"
                        icon="pi pi-pencil"
                        className="btn-text-action-primary"
                        onClick={() => setIsEdit(true)}
                    />
                )}
            </div>
            <div className='student-master-form'>
                <div className='student-profile-header p-d-flex'>
                    <div className="p-d-flex">
                        <div style={{ height: 200, width: 210 }}>
                            <UploadFile label='' note='' preview={previewProfilePath} original={profilePath} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={isEdit} aspectRatio={null} />
                        </div>
                        <div className="student-header-profile-info p-pl-2">
                            <h2 className='p-text-justify'>{fullName}</h2>
                            <div className='p-d-flex p-ai-center'>
                                <Badge value={`Teacher ID - ${teacherId}`} className='common-badge' />
                                <Badge value={`Shift Time - ${shiftTime ?? ''}`} className='p-ml-2 common-badge' />
                            </div>
                            <div className='p-d-flex p-ai-center p-mt-2'>
                                <div style={{ height: 120, width: 160 }}>
                                    <UploadFile label='Sign' note='' preview={previewSignPath} original={signPath} uploadHandler={uploadHandler} uploadRef={signUploadRef} handleDelete={handleDelete} isEditAllow={isEdit} aspectRatio={null} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-ml-auto">
                        <div className="p-d-flex p-flex-column p-ai-end">
                            <div className='p-mb-2'>
                                <p className='badge-label p-mb-1'>Designation</p>
                                <div className="p-d-flex p-ai-center">
                                    {isClassTeacher && <Badge value="Class Teacher" className="common-badge" severity="success" />}
                                    {isSubjectTeacher && <Badge value="Subject Teacher" className="common-badge p-ml-2" severity="info" />}
                                </div>
                            </div>
                            
                            <div>
                                <p className='badge-label p-mb-1'>Subject Taught</p>
                                <div className="p-d-flex p-ai-center p-flex-wrap">
                                    {assignedSubject?.map((x, idx) => {
                                        return <Badge key={idx} value={x} className="common-badge p-m-1" />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='p-mb-2'>
                                <p className='badge-label p-mb-1 p-text-center'>Assigned Class & Section</p>
                                <div className="p-d-flex p-ai-center p-jc-center p-flex-wrap">
                                    {assignedClass?.map((x, idx) => {
                                        return (
                                            <Badge 
                                                key={idx}
                                                value={x}
                                                className="common-badge p-m-1"
                                                severity={x === classTeacherName ? "warning" : "secondary"}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                <TabView className='p-mt-3' activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                    <TabPanel header="Personal Details">
                        <div className="p-mb-0">
                            <div className="p-grid p-ai-center p-py-2">
                                <div className="p-col-12 p-md-8">
                                    <div className="p-d-flex" role="tablist" aria-label="Personal details tabs">
                                        <Button
                                            type="button"
                                            className={`p-mr-2 pill-btn ${section === 'Basic Details' ? 'pill-btn--active' : ''}`}
                                            label="Basic Details"
                                            icon={section === 'Basic Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setSection('Basic Details')}
                                        />
                                        <Button
                                            type="button"
                                            className={`pill-btn ${section === 'Contact Details' ? 'pill-btn--active' : ''}`}
                                            label="Contact Details"
                                            icon={section === 'Contact Details' ? 'pi pi-check' : undefined}
                                            onClick={() => setSection('Contact Details')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-fluid">
                                {section === 'Basic Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="fullName">Full Name</label>
                                                <InputText className='p-mt-1' id="fullName" maxLength={20} value={fullName} disabled={!isEdit} onChange={(e) => handleChange(e, 'FullName')} />
                                                <span className="error-msg" style={{ color: 'red' }}>
                                                    {emailErr ? emailErrText : null}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="aadhar">Aadhar</label>
                                                <div className="p-inputgroup p-d-flex p-mt-1 p-ai-center">
                                                    <InputText className='p-w-100' id="aadhar" value={aadharNo} maxLength={12} disabled={!isEdit} onChange={(e) => handleChange(e, 'AadharNo')} />
                                                    <Button className='p-pr-4 p-pl-3' label="Verify" disabled={!isEdit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="gender">Gender</label>
                                                <Dropdown id="gender" className='p-mt-1' disabled={!isEdit} value={selectedGender} options={genderOptions} onChange={(e) => setSelectedGender(e.value)} placeholder="Select Gender" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="dob">Date of Birth</label>
                                                <Calendar className='p-w-100 p-mt-1' id="dob" value={dob} onChange={handleDobChange} disabled={!isEdit} dateFormat='dd/mm/yy' maxDate={new Date()} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="age">Age</label>
                                                <InputText id="age" className='p-mt-1' value={age} disabled />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="nationality">Nationality</label>
                                                <Dropdown id="nationality" className='p-mt-1' value={selectedNationality} disabled={!isEdit} options={nationalityOptions} onChange={(e) => setSelectedNationality(e.value)} placeholder="Select Nationality" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="bloodGroup">Blood Group</label>
                                                <Dropdown id="bloodGroup" className='p-mt-1' value={selectedBloodGroup} options={bloodList} disabled={!isEdit} onChange={(e) => setSelectedBloodGroup(e.value)} placeholder="Select Blood Group" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="religion">Religion</label>
                                                <Dropdown id="religion" className='p-mt-1' value={selectedReligion} options={religionList} disabled={!isEdit} onChange={(e) => setSelectedReligion(e.value)} placeholder="Select Religion" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="category">Category</label>
                                                <Dropdown id="category" className='p-mt-1' value={selectedCategory} options={casteList} disabled={!isEdit} onChange={(e) => setSelectedCategory(e.value)} placeholder="Select Category" showClear filter />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="languages">Languages Spoken</label>
                                                <MultiSelect id="languages" className='p-mt-1' value={languages} options={languageList} disabled={!isEdit} onChange={(e) => setLanguages(e.value)} placeholder="Select language" filter display='chip' />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-3">
                                            <div className="custom-inputs">
                                                <label htmlFor="typeName">Type Name</label>
                                                <Dropdown className='p-mt-1' id="typeName" disabled={!isEdit} value={typeName} options={typeList} onChange={(e) => setTypeName(e.value)} placeholder="Select Type" filter showClear />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {section === 'Contact Details' && (
                                    <div className='p-grid'>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="emailId">Email Address</label>
                                                <InputText className='p-w-100 p-mt-1' id="emailId" value={emailAddress} disabled={!isEdit} onChange={(e) => handleEmailChange(e)} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="contactNo">Contact Number</label>
                                                <InputText id="contactNo" className='p-mt-1 p-w-100' maxLength={10} value={mobileNumber} disabled={!isEdit} onChange={(e) => handleChange(e, 'MobileNo')} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="emrContactNo">Emergency Contact Number</label>
                                                <InputText id="emrContactNo" className='p-mt-1 p-w-100' maxLength={10} disabled={!isEdit} value={alternateMobileNumber} onChange={(e) => handleChange(e, 'AlternateNo')} />
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="pinCode">Pin Code</label>
                                                <InputText className='p-w-100 p-mt-1' id="pinCode" value={pinCode} maxLength={6} disabled={!isEdit} onChange={(e) => handleChange(e, 'PinCode')} />
                                            </div>
                                        </div>
                                        <div className="p-col-12">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="currentAddress">Current Address</label>
                                                <InputTextarea className='p-w-100 p-mt-1' id="currentAddress" maxLength={100} value={currentAddress} type='textArea' rows={3} cols={30} onChange={(e) => setCurrentAddress(e.target.value)} disabled={!isEdit} />
                                            </div>
                                        </div>
                                        <div className="p-col-12">
                                            <div className="p-d-flex p-ai-center">
                                                <Checkbox
                                                    inputId="randomCheckbox"
                                                    checked={isRandom}
                                                    disabled={!isEdit}
                                                    onChange={(e) => handleCheckBox(e)}
                                                />
                                                <label className='p-d-block' htmlFor="randomCheckbox" style={{ marginLeft: '8px' }}>Permanent address same as current</label>
                                            </div>
                                        </div>
                                        <div className="p-col-12">
                                            <div className="custom-inputs">
                                                <label className='p-d-block' htmlFor="permanentAddress">Permanent Address</label>
                                                <InputTextarea className='p-w-100 p-mt-1' id="permanentAddress" maxLength={100} value={permanentAddress} rows={3} cols={30} onChange={(e) => setPermanentAddress(e.target.value)} disabled={!isEdit} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Employment Details">
                        <div className="p-mb-0 p-py-2">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="doj">Date of Joining</label>
                                        <Calendar className='p-w-100 p-mt-1' id="doj" value={doj} onChange={(e) => setDoj(e.value)} disabled={!isEdit} dateFormat='dd/mm/yy' />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="experience">Years of Experience</label>
                                        <InputText className='p-w-100 p-mt-1' id="experience" maxLength={2} value={experience} onChange={(e) => handleChange(e, 'Experience')} disabled={!isEdit} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="lastOrganization">Last Organization</label>
                                        <InputText className='p-w-100 p-mt-1' id="lastOrganization" maxLength={40} value={lastOrganzation} onChange={(e) => handleChange(e, 'LastOrganization')} disabled={!isEdit} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="lastJobPosition">Last Job Position</label>
                                        <InputText className='p-w-100 p-mt-1' id="lastJobPosition" maxLength={30} value={position} onChange={(e) => handleChange(e, 'LastJob')} disabled={!isEdit} />
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="custom-inputs">
                                        <label className='p-d-block' htmlFor="shift">Shift</label>
                                        <Dropdown className='p-w-100 p-mt-1' id="shiftId" value={selectedShiftId} options={shiftList} disabled={!isEdit} onChange={(e) => setSelectedShiftId(e.value)} placeholder="Select Shift" filter showClear />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Qualification Details">
                        <div className="p-py-2">
                            {qualifications.map((qualification, index) => (
                                <div key={qualification.id} className="qualification-section">
                                    <div className='p-d-flex p-ai-center p-jc-between'>
                                        <h4>Qualification {index + 1}</h4>
                                        <Button
                                            icon="pi pi-trash"
                                            className="p-button-rounded p-button-danger p-button-sm p-d-flex p-m-0"
                                            disabled={!isEdit}
                                            onClick={() => removeQualification(qualification._id)}
                                        />
                                    </div>
                                    <hr className='p-m-0' />
                                    <div className="p-grid p-mt-2">
                                        <div className="p-col-4">
                                            <div className="custom-inputs">
                                                <label htmlFor={`degree${qualification.id}`}>Degree</label>
                                                <div className="p-field">
                                                    <InputText
                                                        id={`degree${qualification.id}`}
                                                        value={qualification.degree}
                                                        disabled={!isEdit}
                                                        onChange={(e) => updateQualification(qualification.id, 'degree', e.target.value)}
                                                        className='p-w-100 p-mt-1'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-4">
                                            <div className="custom-inputs">
                                                <label htmlFor={`passingYear${qualification.id}`}>Passing Year</label>
                                                <div className="p-field">
                                                    <Dropdown
                                                        id={`passingYear${qualification.id}`}
                                                        value={qualification.passingYear}
                                                        options={yearOptions}
                                                        disabled={!isEdit}
                                                        onChange={(e) => updateQualification(qualification.id, 'passingYear', e.value)}
                                                        placeholder="Select Year"
                                                        className='p-w-100 p-mt-1'
                                                        filter showClear
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-4">
                                            <div className="custom-inputs">
                                                <label htmlFor={`college${qualification.id}`}>College</label>
                                                <div className="p-field">
                                                    <InputText
                                                        id={`college${qualification.id}`}
                                                        value={qualification.college}
                                                        disabled={!isEdit}
                                                        onChange={(e) => updateQualification(qualification.id, 'college', e.target.value)}
                                                        className='p-w-100 p-mt-1'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-4">
                                            <div className="custom-inputs">
                                                <label htmlFor={`university${qualification.id}`}>University</label>
                                                <div className="p-field">
                                                    <InputText
                                                        id={`university${qualification.id}`}
                                                        value={qualification.university}
                                                        disabled={!isEdit}
                                                        onChange={(e) => updateQualification(qualification.id, 'university', e.target.value)}
                                                        className='p-w-100 p-mt-1'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-4">
                                            <div className="custom-inputs">
                                                <label htmlFor={`percentage${qualification.id}`}>Percentage</label>
                                                <div className="p-field">
                                                    <InputText
                                                        id={`percentage${qualification.id}`}
                                                        value={qualification.percentage}
                                                        disabled={!isEdit}
                                                        maxLength={3}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                updateQualification(qualification.id, 'percentage', value);
                                                            }
                                                        }}
                                                        onKeyPress={(e) => {
                                                            const char = String.fromCharCode(e.which);
                                                            if (!/[\d.]/.test(char)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className='p-w-100 p-mt-1'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {isEdit ?
                                <div className="p-mt-3">
                                    <Button label="Add Qualification" icon="pi pi-plus" className="btn-text-action-primary" onClick={addQualification} />
                                </div> : null}
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            <div className='edit-profile-footer p-d-flex p-jc-end p-ai-center p-pr-4'>
                <Button label="Back" className="btn-text-action-secondary" onClick={() => navigate('/teacher-master')} />
                {isEdit ?
                    <Button label="Save" className='btn-text-action-primary' icon="pi pi-check" onClick={() => saveDetails()} /> : null}
            </div>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div >
    );
}

export default ViewEditTeacherDetails;
